import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post, postFormData } from ".";

/**
 * Asynchronous function to get the top search results.
 *
 * @param {object} data - The data for the search request
 * @return {Promise} The result of the post request
 */
export const _getTopSearchResults = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.generalSearch,
    data,
  };
  return await post(request);
};

export const _updateQRCode = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getQrCode,
    data,
  };
  return await post(request);
};

export const _BulkUploadShiftsHeader = async (data) => {
  let formData = new FormData();
  formData.append("import_file", data.import_file);
  return postFormData(serviceRouteConstants?.bulkUploadShifts, formData);
};

export const _updateTourGuide = async (data) => {
  // console.log("data",data)

  const postData = {
    client_user_email: data,
  };
  const request = {
    endPoint: serviceRouteConstants.updateTourGuide,
    data: postData,
  };
  return await post(request);
};
